import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedWeight: 'light',
  selectedJacketSize: 'M',
  selectedFit: 'classic', // 'classic' or 'slim'
  selectedPatches: {
    'ZIP': null,
    'Right Arm': null,
    'Left Arm': null,
    'Back Side': null
  },
  customPhoto: null,
  bodyMeasurements: {
    chest: '',
    bodyLength: '',
    sleeveLength: '',
    armWidth: '',
    waist: '',
    shoulderToShoulder: ''
  }
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSelectedWeight: (state, action) => {
      state.selectedWeight = action.payload;
    },
    setSelectedJacketSize: (state, action) => {
      state.selectedJacketSize = action.payload;
    },
    setSelectedPatches: (state, action) => {
      state.selectedPatches = action.payload;
    },
    setCustomPhoto: (state, action) => {
      state.customPhoto = action.payload;
    },
    setBodyMeasurements: (state, action) => {
      state.bodyMeasurements = action.payload;
    },
    setSelectedFit: (state, action) => {
      state.selectedFit = action.payload;
    }
  }
});

export const {
  setSelectedWeight,
  setSelectedJacketSize,
  setSelectedPatches,
  setCustomPhoto,
  setBodyMeasurements,
  setSelectedFit
} = appSlice.actions;

export default appSlice.reducer;
